import { useQuery } from '@tanstack/react-query';
import { loadImporterSeasonBundle } from '../utils/api';

/**
 * Season Summary bundle for the map cards and modal. Its own request, so a
 * failing shipments call cannot block Season and a failing bundle cannot block
 * shipments. Query key includes the account so ACL-gated packs never leak
 * across users.
 */
export default function useSeasonBundle({ email = '' } = {}) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['importer-report', 'season-bundle', email || ''],
    queryFn: loadImporterSeasonBundle,
    // Short freshness + refetch on refocus: an access change (domain/tier/email) shows within about a minute.
    staleTime: 60 * 1000,
    refetchOnWindowFocus: true,
    retry: 1,
  });
  return { data, isLoading, isError };
}
